import authLoader from '../../../routes/authLoader';
import AlertListPage from '../AlertListPage';
import AddNewAlert from './AddNewAlertPage';

export const alertRoutes = [
  {
    path: 'new_alert',
    loader: authLoader,
    element: <AddNewAlert />,
  },
  {
    path: 'alerts',
    loader: authLoader,
    element: <AlertListPage />,
  },
  {
    path: 'edit_alert',
    loader: authLoader,
    element: <AddNewAlert />,
  },
];
